import { Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { map, switchMap } from "rxjs/operators";
import * as type from './actionTypes';
import * as ContractTemplateAction from './actions';
import { ContractTemplateService } from "./service";

@Injectable()
export class ContractTemplateEffect {
    constructor(
        private action: Actions,
        private ContractTemplateService: ContractTemplateService
    ) { }

    GetContractTemplateList = createEffect(() => this.action.pipe(
        ofType(type.GET_CONTRACT_TEMPLATE_LIST),
        switchMap(() => this.ContractTemplateService.getContractTemplateList()),
        map((data: Array<any>) => new ContractTemplateAction.SetContractTemplateList(data)
        )
    ));
    
    GetContractTemplateListByOrganisation = createEffect(() => this.action.pipe(
        ofType(type.GET_CONTRACT_TEMPLATE_LIST_ORGANISATION_ID),
        switchMap((data: any) => this.ContractTemplateService.getContractTemplateListByOrganisation(data.payload)),
        map((data: Array<any>) => new ContractTemplateAction.SetContractTemplateList(data)
        )
    ));

    ContractTemplateById = createEffect(() => this.action.pipe(
        ofType(type.GET_CONTRACT_TEMPLATE_BY_ID),
        switchMap((data: any) => this.ContractTemplateService.getContractTemplateById(data.payload)),
        map((data: Array<any>) => new ContractTemplateAction.SetContractTemplateById(data)
        )
    ));

    AddContractTemplate = createEffect(() => this.action.pipe(
        ofType(type.ADD_CONTRACT_TEMPLATE),
        switchMap((data: any) => this.ContractTemplateService.addContractTemplate(data.payload)),
        map((data) => new ContractTemplateAction.AddContractTemplateResponse(data)
        )
    ));

    UpdateContractTemplate = createEffect(() => this.action.pipe(
        ofType(type.UPDATE_CONTRACT_TEMPLATE),
        switchMap((data: any) => this.ContractTemplateService.updateContractTemplate(data.payload)),
        map((data) => new ContractTemplateAction.UpdateContractTemplateResponse(data)
        )
    ));

    DeleteContractTemplate = createEffect(() => this.action.pipe(
        ofType(type.DELETE_CONTRACT_TEMPLATE),
        switchMap((data: any) => this.ContractTemplateService.deleteContractTemplate(data.payload)),
        map((data) => new ContractTemplateAction.DeleteContractTemplateResponse(data)
        )
    ));
}
